import { AlertTriangle } from 'lucide-react'

import { Badge } from '@/components/ui'
import { useI18n } from '@/i18n'
import { cn } from '@/lib/cn'

export interface CapabilityWarningBadgeProps {
  inconsistent?: boolean
  className?: string
}

export function CapabilityWarningBadge({
  inconsistent,
  className,
}: CapabilityWarningBadgeProps) {
  const { t } = useI18n()

  if (inconsistent !== true) return null

  const label = t('modelSelect.capabilityInconsistent')
  const tooltip = t('modelSelect.capabilityInconsistentTooltip')

  return (
    <Badge
      variant="warning"
      size="sm"
      className={cn('shrink-0 px-1.5 py-0 text-[10px] leading-4', className)}
      title={tooltip}
      aria-label={`${label}: ${tooltip}`}
    >
      <AlertTriangle className="h-3 w-3" aria-hidden />
      {label}
    </Badge>
  )
}
